// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3kCmp","buttons":"Footer_buttons__1hRhQ"};